import cn from "classnames";
import styles from "./Pager.module.sass";

const Pager = ({ total, setPage, range = 1, page }) => {
	const arr = Array.from({ length: range * 2 + 1 }, (_, i) => i + page - range);
	return (
		<>
			{page - range > 1 && (
				<button
					onClick={() => setPage(1)}
					className={"button-stroke button-small"}
				>
					<span>1</span>
				</button>
			)}
			{page - range > 2 && (
				<button className={cn("button-stroke disabled button-small")}>
					<span>...</span>
				</button>
			)}
			{arr.map((e) => {
				if (1 <= e && e <= total)
					return (
						<button
							key={e}
							onClick={() => setPage(e)}
							className={`button${e !== page && "-stroke"} button-small`}
						>
							<span>{e}</span>
						</button>
					);
				return "";
			})}
			{page + range < total - 1 && (
				<button className={cn("button-stroke disabled button-small")}>
					<span>...</span>
				</button>
			)}
			{page + range < total && (
				<button
					onClick={() => setPage(total)}
					className={"button-stroke button-small"}
				>
					<span>{total}</span>
				</button>
			)}
		</>
	);
};

export { Pager };
